import * as React from "react";
import type { SVGProps } from "react";
const SvgBackpack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#backpack_svg__a)">
      <path d="M16 4V3a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1a9 9 0 0 0-5 8v9a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-9a9 9 0 0 0-5-8m-6-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1zm9 18a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a7 7 0 0 1 14 0z" />
      <path d="M9 9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3zm6 10H9a1 1 0 0 1-1-1v-3h8v3a1 1 0 0 1-1 1m1-7v1H8v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
    </g>
    <defs>
      <clipPath id="backpack_svg__a">
        <path fill="#fff" d="M3 0h18v24H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBackpack;
